import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { PhaseType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { PHASES } from "../../utils/constants";

export const createPhase = async (data: PhaseType) => await post<PhaseType, string>(PHASES, data);
export const updatePhase = async (data: PhaseType) => await put<PhaseType, string>(PHASES, data);

export const getPhases = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdProjectType ? { IdProjectType: data.IdProjectType  } : {}),

    });
    const url = `${PHASES}?${queryParams.toString()}`;
    return await get<PagedResultsType<PhaseType>>(url);
};
